import { enableProdMode, NgModuleRef, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// original - shows Angular app
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

// simple - fails
// Office.initialize = (reason) => {
//   console.log('Initialise Office Application', reason);
//   platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch((error) => console.error(error));
// };

// complex
// www.npmjs.com/package/@microsoft/office-js
Reference: https: if (Office !== undefined) {
  Office.initialize = (reason) => {
    Office.onReady()
      .then((_info: { host: Office.HostType; platform: Office.PlatformType }) => {
        console.log('Office is ready.', reason);
        return bootStrapAngular();
      })
      .catch((err) => {
        console.warn('Angular not bootstrapped. Error: \n');
        console.log(err);
      });
  };

  // Office.initialize(0); // Start
} else {
  console.log('Bootstrapping Angular, without Office JS');
  bootStrapAngular();
}

function bootStrapAngular(): Promise<void | NgModuleRef<AppModule>> {
  return platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch((error) => {
      console.log('Error bootstrapping Office Angular app: ', error);
    });
}
